import { useState } from "react";
import PropTypes from "prop-types";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import DefaultLogo from "assets/images/logovietgrp.svg";
import "./styles.less";
import { Avatar, Image, Row } from "antd";
import { ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import ReactPlayer from "react-player";
import Linkify from "react-linkify";
import { PlaceHolderIMG, StockExist, Removed, SoldOut } from "assets/images";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import OrderMessage from "./OrderMessage";
import moment from "moment";

const formatMessageTime = (date) => {
  if (!date) return '';
  return moment(date).format('HH:mm');
};

const MessageCell = ({ data = {}, isOwnCell, onRetry, showAvatar = true }) => {
  const name = useSelector((state) => _get(state, "auth.currentUser.name"));
  const avatar = _get(data, "sender.userDetail.avatar") || DefaultLogo;
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const attachments = _get(data, "attachments", []) || [];
  const videos = attachments.filter((att) => att.type === "video");
  const images = attachments.filter((att) => att.type === "image");

  // Check if this is an optimistic (sending) message
  const isOptimistic = data.isOptimistic;
  const isFailed = data.status === 'failed';
  const isRecalled = data.isRecalled;
  const isEdited = data.isEdited;

  // Render recalled message
  if (isRecalled) {
    return (
      <div className={`message-cell-container ${isOwnCell ? "own-cell-container" : ""}`}>
        <div className={`flex ${isOwnCell ? "flex-end" : ""}`}>
          {!isOwnCell && (
            showAvatar
              ? <Avatar size={32} src={avatar} className="avatar" />
              : <div className="avatar-placeholder" style={{ width: 32, minWidth: 32 }} />
          )}
          <div className="message-text-container message-recalled">
            <span>Tin nhắn đã được thu hồi</span>
          </div>
        </div>
      </div>
    );
  }

  const componentDecorator = (href, text, key) => (
    <a
      className={isOwnCell ? "self-message" : "other-message"}
      href={href}
      key={key}
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
    </a>
  );

  const renderStatusProduct = (soldOut) => {
    switch (soldOut) {
      case 0:
        return <div className="status-content">Còn hàng</div>;
      case 1:
        return <div className="status-content">Hết hàng</div>;
      default:
        return <div className="status-content">Đã xoá</div>;
    }
  };

  const renderStatusProductIcon = (soldOut) => {
    switch (soldOut) {
      case 0:
        return <Image src={StockExist} />;
      case 1:
        return <Image src={SoldOut} />;
      default:
        return <Image src={Removed} />;
    }
  };

  const toggleDescriptionExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDescriptionExpanded(!isDescriptionExpanded);
  };

  const renderProductItem = () => {
    const description = _get(data, "productDetail.description", "");
    const shouldShowToggle = description && description.length > 100;

    return (
      <Link to={`/fonehouse/products/${_get(data, "productDetail._id")}`}>
        <div
          className="product-container"
          style={{ width: 280, alignSelf: "flex-end" }}
        >
          <Image
            fallback={PlaceHolderIMG}
            src={_get(data, "productDetail.images[0]")}
            preview={false}
          />
          <div className="promotion-box">
            <div className="text-promotion">
              {_get(data, "productDetail.percentagePromotion", 0)}%
            </div>
          </div>
          <Row className={`status-box-${_get(data, "productDetail.soldOut")}`}>
            {renderStatusProductIcon(_get(data, "productDetail.soldOut"))}
            {renderStatusProduct(_get(data, "productDetail.soldOut"))}
          </Row>
          <div style={{ padding: 16 }}>
            <div className="product-name">
              {_get(data, "productDetail.name", "--/--")}
            </div>
            <div className="product-info">
              <b>Bộ nhớ:</b> {_get(data, "productDetail.ram", "--/--")}
            </div>
            <div className="product-info">
              <b>Dòng: </b>
              {_get(data, "productDetail.lineDescription", "--/--")}
            </div>
            <div className="product-info">
              <b>Mô tả chi tiết:</b>{" "}
              <span className={`product-description ${isDescriptionExpanded ? 'expanded' : 'collapsed'}`}>
                {description || "--/--"}
              </span>
              {shouldShowToggle && (
                <span className="expand-toggle" onClick={toggleDescriptionExpand}>
                  {isDescriptionExpanded ? 'Thu gọn' : 'Xem thêm'}
                </span>
              )}
            </div>
            <div className="product-price">
              円 {data?.productDetail?.promotionPriceJPY?.toLocaleString() ?? 0}
            </div>
          </div>
        </div>
      </Link>
    );
  };

  const renderOrderDetail = () => {
    if (data.orderDetail && Object.keys(data?.orderDetail).length !== 0) {
      return <OrderMessage orderDetail={data.orderDetail} />;
    }
    return <div></div>;
  };

  if (data.type === "product" && _get(data, "productDetail._id")) {
    return (
      <div
        className={`message-cell-container ${
          isOwnCell ? "own-cell-container" : ""
        }`}
        style={{ opacity: isOptimistic ? 0.7 : 1 }}
      >
        <div className={`flex ${isOwnCell ? "flex-end" : ""}`}>
          {!isOwnCell && (
            showAvatar
              ? <Avatar size={32} src={avatar} className="avatar" />
              : <div className="avatar-placeholder" style={{ width: 32, minWidth: 32 }} />
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: isOwnCell ? "flex-end" : "flex-start",
              width: "100%",
            }}
          >
            {data.text && (
              <div className="message-text-container">
                <Linkify componentDecorator={componentDecorator}>
                  {data.text}
                </Linkify>
                {isEdited && <span className="edited-label">(đã chỉnh sửa)</span>}
                <span className="message-time-inline">{formatMessageTime(data.createdAt)}</span>
              </div>
            )}

            {!_isEmpty(videos) && (
              <div className="video-container">
                {videos.map((video, index) => (
                  <div key={index} className="media-wrapper">
                    <ReactPlayer
                      style={{ marginLeft: "auto" }}
                      controls
                      url={_get(video, "data.videoUrl")}
                      width={200}
                      height="100%"
                    />
                    <span className="media-time-overlay">{formatMessageTime(data.createdAt)}</span>
                  </div>
                ))}
              </div>
            )}
            {!_isEmpty(images) && (
              <div className="image-gallery-container">
                <Image.PreviewGroup>
                  {images.map((img, index) => (
                    <div key={index} className="media-wrapper">
                      <Image
                        src={_get(img, "data.imageUrl")}
                        style={{ maxWidth: 120, maxHeight: 120, objectFit: "contain" }}
                      />
                      {index === images.length - 1 && (
                        <span className="media-time-overlay">{formatMessageTime(data.createdAt)}</span>
                      )}
                    </div>
                  ))}
                </Image.PreviewGroup>
              </div>
            )}

            {data.type === "product" &&
              _get(data, "productDetail._id") &&
              renderProductItem()}
            {isOwnCell ? (
              <div className="send-by-container">
                <div className="send-by">
                  Được gửi từ {data.sender.name ?? name}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
  if (data.type !== "product") {
    const hasOnlyText = data.text && _isEmpty(videos) && _isEmpty(images) && !data.orderDetail;
    const hasMedia = !_isEmpty(videos) || !_isEmpty(images);

    return (
      <div
        className={`message-cell-container ${
          isOwnCell ? "own-cell-container" : ""
        }`}
        style={{ opacity: isOptimistic ? 1 : 1 }}
      >
        <div className={`flex ${isOwnCell ? "flex-end" : ""}`}>
          {!isOwnCell && (
            showAvatar
              ? <Avatar size={32} src={avatar} className="avatar" />
              : <div className="avatar-placeholder" style={{ width: 32, minWidth: 32 }} />
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: isOwnCell ? "flex-end" : "flex-start",
              width: "100%",
            }}
          >
            {data.text && (
              <div
                className={`message-text-container ${isFailed ? 'message-failed' : ''} ${isOptimistic && !isFailed ? 'message-sending' : ''}`}
                onClick={isFailed ? () => onRetry && onRetry(data) : undefined}
                style={isFailed ? { cursor: 'pointer' } : {}}
              >
                <Linkify componentDecorator={componentDecorator}>
                  {data.text}
                </Linkify>
                {isEdited && <span className="edited-label">(đã chỉnh sửa)</span>}
                {hasOnlyText && !isFailed && !isOptimistic && <span className="message-time-inline">{formatMessageTime(data.createdAt)}</span>}
                {isOptimistic && !isFailed && (
                  <div className="sending-indicator">
                    <LoadingOutlined spin /> Đang gửi...
                  </div>
                )}
                {isFailed && (
                  <div className="retry-indicator">
                    <ExclamationCircleOutlined /> Gửi thất bại - Bấm để thử lại
                  </div>
                )}
              </div>
            )}

            {!_isEmpty(videos) && (
              <div className="video-container">
                {videos.map((video, index) => (
                  <div key={index} className="media-wrapper">
                    <ReactPlayer
                      style={{ marginLeft: "auto" }}
                      controls
                      url={_get(video, "data.videoUrl")}
                      width={200}
                      height="100%"
                    />
                    {_isEmpty(images) && index === videos.length - 1 && (
                      <span className="media-time-overlay">{formatMessageTime(data.createdAt)}</span>
                    )}
                  </div>
                ))}
              </div>
            )}
            {!_isEmpty(images) && (
              <div className="image-gallery-container">
                <Image.PreviewGroup>
                  {images.map((img, index) => (
                    <div key={index} className="media-wrapper">
                      <Image
                        src={_get(img, "data.imageUrl")}
                        style={{ maxWidth: 300, maxHeight: 300, objectFit: "contain" }}
                      />
                      {index === images.length - 1 && (
                        <span className="media-time-overlay">{formatMessageTime(data.createdAt)}</span>
                      )}
                    </div>
                  ))}
                </Image.PreviewGroup>
              </div>
            )}
            {renderOrderDetail()}
            {!hasOnlyText && !hasMedia && (
              <div className="message-time-bottom">{formatMessageTime(data.createdAt)}</div>
            )}
            {data.type === "product" &&
              _get(data, "productDetail._id") &&
              renderProductItem()}
            {isOwnCell ? (
              <div className="send-by-container">
                <div className="send-by">
                  Được gửi từ {data.sender.name ?? name}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
  return <div></div>;
};

MessageCell.propTypes = {
  data: PropTypes.object,
  isOwnCell: PropTypes.bool,
  onRetry: PropTypes.func,
  onDismiss: PropTypes.func,
  showAvatar: PropTypes.bool,
};

export default MessageCell;
